export function useSessionStorage() {
  const setSessionItem = (key: string, value: any): void => {
    try {
      const serializedValue = JSON.stringify(value)
      sessionStorage.setItem(key, serializedValue)
    } catch (error) {
      console.error(`Error setting item in sessionStorage: ${error}`)
    }
  }

  /**
   * Get an item from sessionStorage
   * @returns The parsed value, or null if not found or error occurs
   */
  const getSessionItem = <T>(key: string): T | null => {
    try {
      const item = sessionStorage.getItem(key)
      return item ? (JSON.parse(item) as T) : null
    } catch (error) {
      console.error(`Error getting item from sessionStorage: ${error}`)
      return null
    }
  }

  const deleteSessionItem = (key: string): void => {
    try {
      sessionStorage.removeItem(key)
    } catch (error) {
      console.error(`Error deleting item from sessionStorage: ${error}`)
    }
  }

  return {
    setSessionItem,
    getSessionItem,
    deleteSessionItem,
  }
}
